import { Company, Game } from "@/types-games";

// API Configuration
export const API_CONFIG = {
  // Use local API for development, production API for production
  BASE_URL: process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001/api'
    : 'https://locanest-api.vercel.app/api', // ⚠️ VERIFY this URL is correct for your production API
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh',
      VALIDATE: '/auth/validate',
      SIGNUP: '/auth/signup',
      EXCHANGE_SESSION: '/auth/exchange-session',
    },
    USER: {
      COMPANIES_GAMES: '/user-companies-games',
      COMPANY_USERS: '/users',
      GAME_USERS: '/users/game',
    },
    DATA: {
      DIALOGUE_LINES: '/strings-original',
      GLOSSARY_ITEMS: '/objects',
      GLOSSARY_BLUEPRINTS: '/templates',
      BLUEPRINT_VERSIONS: '/blueprint-versions',
      BLUEPRINT_MIGRATIONS: '/blueprint-migrations',
      GLOSSARY_VERSIONS: '/object-versions',
      STRINGS_ORIGINAL: '/strings-original',
      DOCUMENT_ITEMS: '/document-items',
      UI_ELEMENTS: '/ui-elements',
      TRANSLATION_LINES: '/translation-lines',
      GAMES: '/games',
      COMPANIES: '/companies',
      PROFILES: '/profiles',
      DIALOGS: '/dialogs',
      LOGIC_FLOWS: '/logic-flows',
    },
    BETA: {
      APPLY: '/beta',
    },
    INTERESTED_USERS: {
      ADD: '/interested-users',
    },
    FAVORITES: {
      GET: '/favorites',
      ADD: '/favorites',
      REMOVE: '/favorites',
    },
  },
} as const;

// Helper function to build API URLs
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// API Response types
export interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
  statusCode?: number;
}

export interface LoginResponse {
  user: {
    id: string;
    email: string;
    full_name: string;
    bio: string;
    settings: Record<string, unknown>;
    Last_Online: string;
    username: string;
    avatar_url: string;
    created_at: string;
    updated_at: string
  };
  token: string;
  expiresIn: string;
}

export interface UserCompaniesGamesResponse {
  company: Company;
  games: Game[];
}

// API Request Retry Configuration
export const API_RETRY_CONFIG = {
  RETRY_DELAY_MS: 5000, // 5 seconds before retry
  FAILURE_BLOCK_DURATION_MS: 30000, // 30 seconds to block repeated calls after failure
  MAX_RETRY_ATTEMPTS: 1, // Retry once on failure
} as const;